import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useConnectionMode from '../../hooks/useConnectionMode';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';
import { Text } from '../custom/text';
import { Card } from 'antd';
import { Flex } from '@react-css/flex';
import { Box } from '../custom/box';
import amIVisible from '../../componentControl/registry';

export const MapTips = () => {
  const [, softwareName] = useConnectionMode();
  const [isLoading, accountsList] = useAccounts('tips');
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  const isRequired = amIVisible("tips required")

  return <Card type="inner"   title={
    <Text fontSize={"large"} fontWeight="bolder">{t('Tips')}</Text>
  } style={{ marginBottom: "1rem" }}>
    <Text color="gray-600" mr="3.25rem" size="small">
      {t('MapTipsDesc', { swName: softwareName })}
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        {isRequired ?  <LabelRequired htmlFor="Tips">
          {
            t(isInputsOnlyLayout ? 'Enter tips account' : 'Select a tips account')
          } 
        </LabelRequired> : <div style={{ marginBottom: "20px" }}></div> }
        <Autocomplete
          isLoadingOptions={isLoading}
          id="Tips"
          name="Tips"
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter tips account' : 'Select an account')
          }
        />
      </Box>
    </Flex>
  </Card>;
};
